const Constants = {
    header_height : 80
}

export default Constants